"use strict";
var logo = document.querySelector(".logo");
var promise1 = new Promise(function(resolve, reject) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error());
    }, 3000);
});
function handleSuccess() {
    var div = document.createElement("div");
    div.className = "message";
    div.textContent = "Promise was resolved!";
    document.body.appendChild(div);
}
function handleError() {
    var div = document.createElement("div");
    div.className = "message error-message";
    div.textContent = "Promise was rejected!";
    document.body.appendChild(div);
}
promise1.then(handleSuccess).catch(handleError);
promise2.then(handleSuccess).catch(handleError);

//# sourceMappingURL=index.d148e199.js.map
